import { Writer } from '@api/api';
import { writerApiClient } from '@api/clients';
import { useQuery, UseQueryResult } from 'react-query';

export const fetchWriter = async (id: string): Promise<Writer> => {
  const { data } = await writerApiClient.writersIdGet({ id }, {});

  return data;
};

export const useWriter = (id: string): UseQueryResult<Writer> => {
  return useQuery(['writer', id], async () => fetchWriter(id));
};
